/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Paid_ErrorInputs */

const en_billing_paid_error = /** @type {(inputs: Billing_Paid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment failed. Please try again.`)
};

const id_billing_paid_error = /** @type {(inputs: Billing_Paid_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran gagal. Coba lagi ya.`)
};

/**
* | output |
* | --- |
* | "Payment failed. Please try again." |
*
* @param {Billing_Paid_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_paid_error = /** @type {((inputs?: Billing_Paid_ErrorInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Paid_ErrorInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_paid_error(inputs)
	return en_billing_paid_error(inputs)
});